import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import "./index.scss";

const Button = ({
  label,
  color,
  type,
  size,
  onClick,
  disabled,
  customClassName,
  block,
  icon,
  submit,
  loading,
  logoSrc,
  value,
  iconOnly,
  prepend,
  rounded,
  ...props
}) => {
  const buttonStyle = {};
  let typeClass = "";
  switch (type) {
    case "outlined":
      typeClass = "-outlined";
      break;
    case "ghost":
      typeClass = "-ghost";
      break;
    case "solid":
      typeClass = "-solid";
      break;
    default:
      typeClass = "-solid";
      break;
  }

  let colorClass = "";
  switch (color) {
    case "green":
      colorClass = "-green";
      break;
    case "orange":
      colorClass = "-orange";
      break;
    case "blue":
      colorClass = "-blue";
      break;
    case "red":
      colorClass = "-red";
      break;
    case "white":
      colorClass = "-white";
      break;
    case "gray":
      colorClass = "-gray";
      break;
    case "black":
      colorClass = "-black";
      break;
    default:
  }

  let sizeClass = "";
  switch (size) {
    case "xlarge":
      sizeClass = "-xlarge";
      break;
    case "large":
      sizeClass = "-large";
      break;
    case "medium":
      sizeClass = "-medium";
      break;
    case "small":
      sizeClass = "-small";
      break;
    case "paddingless":
      sizeClass = "-paddingless";
      break;
    default:
      sizeClass = "-medium";
      break;
  }

  const renderLabel = () => {
    if (loading) return <div>Processing...</div>;

    return (
      <>
        {iconOnly ? "" : label}
        {icon ? <span className={`icon-${icon}`} value={value} /> : null}
      </>
    );
  };

  return (
    <button
      type={submit ? "submit" : "button"}
      style={buttonStyle}
      className={cx(
        customClassName,
        "button",
        icon ? "-with-icon" : null,
        iconOnly ? "-icon-only" : null,
        block ? "-block" : null,
        logoSrc ? "-with-logo" : null,
        prepend ? "-prepend" : null,
        rounded ? "-rounded" : null,
        {
          disabled,
          [`${sizeClass}`]: true,
          [`${typeClass}`]: true,
          [`${colorClass}`]: true,
        }
      )}
      onClick={onClick}
      disabled={disabled}
      {...props}
      value={value}
    >
      {logoSrc ? <img className="logo" src={logoSrc} alt="logo" /> : null}
      {renderLabel()}
    </button>
  );
};

Button.propTypes = {
  customClassName: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  block: PropTypes.bool,
  submit: PropTypes.bool,
  loading: PropTypes.bool,
  iconOnly: PropTypes.bool,
  logoSrc: PropTypes.string,
  value: PropTypes.string,
  prepend: PropTypes.bool,
  rounded: PropTypes.bool,
};

Button.defaultProps = {
  label: "",
  prepend: false,
  customClassName: "",
  icon: "",
  block: false,
  color: "black",
  disabled: false,
  submit: false,
  loading: false,
  logoSrc: "",
  value: "",
  size: "medium",
  type: "solid",
  onClick: () => {},
  iconOnly: false,
  rounded: false,
};

export default Button;
